import {Sequence} from 'components/Sequence';
import {Primer3MatchModel} from 'molbio/MolBioConstants';
import {PolymerTabStateAttributes, PolymerTabState} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

interface Primer3TabStateAttributes extends PolymerTabStateAttributes<Sequence> {
  primers: Backbone.Collection<Primer3MatchModel>;
  saving: boolean;
  originalBases: string;
}

interface Primer3TabState {
  get<K extends keyof Primer3TabStateAttributes>(key: K): Primer3TabStateAttributes[K];
  set<K extends keyof Primer3TabStateAttributes>(
    attributeName: K,
    value: Primer3TabStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): Primer3TabState;
  set(obj: Partial<Primer3TabStateAttributes>): Primer3TabState;
}

class Primer3TabState extends PolymerTabState<Sequence> {
  override defaults(): TabStateDefaults & Partial<Primer3TabStateAttributes> {
    return {
      ...super.defaults(),
      title: 'Primer3 Results',
      saving: false,
    };
  }

  override initialize(attributes?: {
    sequence: Sequence;
    primers: Backbone.Collection<Primer3MatchModel>;
  }): void {
    super.initialize(attributes);
    this.set({originalBases: this.get('sequence').bases()});
  }

  haveBasesChanged(): boolean {
    return this.get('sequence').bases() !== this.get('originalBases');
  }

  override close(): void {
    this.trigger('removePrimers');
    super.close();
  }
}

export default Primer3TabState;
